import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { ModalComponent } from "../modal/modal.component";
import { CommonService } from "src/app/common.service";
import { ConfigurationVariablesList } from "std-api";
import { LoginResponse, Registration } from "auth-api";
import { MustMatch } from "../utils/must-match.validator";
import { HttpErrorResponse } from "@angular/common/http";
import { Profile, PaymentMethod } from "profile-api";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  @ViewChild("attentionModal") attentionModal: ModalComponent;
  @ViewChild("welcomeModal") welcomeModal: ModalComponent;

  attentionModalMsg: string;
  loginLoading = false;
  registrationLoading = false;
  loginError = "no_error";
  registrationError = "no_error";
  fromClusterTender: boolean = false;
  fromTender: boolean = false;
  fromQuoteBuy: boolean = false;
  fromCompanyShowcase: boolean = false;
  fromAnnouncementShowcase: boolean = false;
  fromOngoingTenders: boolean = false;
  fromDesignerShowcase: boolean = false;
  fromAcceptInvitation: boolean = false;
  tenderId: number;

  loginForm = new FormGroup({
    loginUsername: new FormControl("", [
      Validators.required,
      Validators.email,
      Validators.pattern(CommonService.EMAIL_REGEXP),
    ]),
    loginPassword: new FormControl("", [Validators.required]),
  });

  registrationForm: FormGroup;
  fromInvitation = false;
  invitationToken = null;
  announcementType: string;

  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    console.log("token " + this.route.queryParams["invitationToken"]);
    this.registrationForm = this.formBuilder.group(
      {
        email: new FormControl("", [
          Validators.required,
          Validators.email,
          Validators.pattern(CommonService.EMAIL_REGEXP),
        ]),
        password: new FormControl("", [Validators.required]),
        passwordConfirm: new FormControl("", [Validators.required]),
        os: new FormControl(window.navigator.userAgent, [Validators.required]),
        ver: new FormControl("1.0", [Validators.required]),
        verApp: new FormControl("1.0", [Validators.required]),
      },
      {
        validator: MustMatch("password", "passwordConfirm"),
      }
    );

    // this.tender = JSON.parse(localStorage.getItem('TEMP_TENDER'));
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe((params) => {
      this.tenderId = params["tenderId"];
      if (params["fromTender"]) {
        this.fromTender = true;
      }
      if (params["fromAcceptInvitation"]) {
        this.fromAcceptInvitation = true;
      }
      if (params["fromQuoteBuy"]) {
        this.fromQuoteBuy = true;
      }

      if (params["fromClusterTender"]) {
        this.fromClusterTender = true;
      }

      if (params["fromCompanyShowcase"]) {
        this.fromCompanyShowcase = true;
      }

      if (params["fromAnnouncementShowcase"]) {
        this.fromAnnouncementShowcase = true;
        this.announcementType = params["announcementType"];
      }

      if (params["fromDesignerShowcase"]) {
        this.fromDesignerShowcase = true;
      }

      if (params["fromOngoingTenders"]) {
        this.fromOngoingTenders = true;
      }

      if (params["invitationToken"]) {
        this.fromInvitation = true;
        this.invitationToken = params["invitationToken"];
      }
      if (this.fromTender || this.fromClusterTender) {
        this.attentionModalMsg =
          "Per poter procedere all'acquisto della gara è necessario effettuare il login o la registrazione.";
        this.attentionModal.open();
      } else if (this.fromAcceptInvitation) {
        this.attentionModalMsg =
          "Per poter accedere alla gara è necessario effettuare il login.";
        this.attentionModal.open();
      } else if (this.fromQuoteBuy) {
        this.attentionModalMsg =
          "Per poter procedere all'acquisto del preventivo è necessario effettuare il login o la registrazione.";
        this.attentionModal.open();
      } else if (this.fromCompanyShowcase || this.fromDesignerShowcase || this.fromOngoingTenders || this.fromAnnouncementShowcase) {
        this.attentionModalMsg =
          "Per poter accedere a quest'area è necessario effettuare il login o la registrazione.";
        this.attentionModal.open();
      }
    });
  }

  getCorrectUrl(baseUrl: string) {
    let url = baseUrl;
    if (this.tenderId) {
      url += "&tenderId=" + this.tenderId;
    }
    return url;
  }

  login(username: string, password: string) {
    var returnPromise = this.commonService.login(username, password);

    returnPromise
      .then((profile: Profile) => {
        if (this.fromTender || this.fromClusterTender || this.fromQuoteBuy) {
          this.commonService
            .saveProfile(profile)
            .then((pro: Profile) => {
              this.commonService
                .getPaymentMethodService()
                .profilePaymentMethodGet()
                .subscribe(
                  (paymentMethod: PaymentMethod) => {
                    if (this.fromInvitation) {
                      window.open(
                        "acquistapartecipazioneallagara?tenderId=" +
                          this.tenderId +
                          "&invitationToken=" +
                          this.invitationToken,
                        "_self"
                      );
                    } else if (this.fromQuoteBuy) {
                      window.open("/acquistarichiestapreventivo", "_self");
                    } else if (this.tenderId) {
                      window.open(
                        "acquistapartecipazioneallagara?tenderId=" +
                          this.tenderId,
                        "_self"
                      );
                    } else if (this.fromClusterTender){
                      window.open("/acquistacreazionegaracluster", "_self");
                    } else {
                       window.open("/acquistacreazionegara", "_self");
                    }
                  },
                  (error) => {
                    if (this.fromTender) {
                      window.open(
                        this.getCorrectUrl(
                          "/areariservata?tabToLoad=paymentMethod&fromTender=yes"
                        ),
                        "_self"
                      );
                    }else if (this.fromClusterTender) {
                      window.open(
                        this.getCorrectUrl(
                          "/areariservata?tabToLoad=paymentMethod&fromClusterTender=yes"
                        ),
                        "_self"
                      );
                    } else if (this.fromQuoteBuy) {
                      window.open(
                        this.getCorrectUrl(
                          "/areariservata?tabToLoad=paymentMethod&fromQuoteBuy=yes"
                        ),
                        "_self"
                      );
                    }
                  }
                );
            })
            .catch((error) => {
              if (this.fromTender) {
                window.open(
                  this.getCorrectUrl(
                    "/areariservata?tabToLoad=profile&fromTender=yes"
                  ),
                  "_self"
                );
              }else if (this.fromClusterTender) {
                window.open(
                  this.getCorrectUrl(
                    "/areariservata?tabToLoad=profile&fromClusterTender=yes"
                  ),
                  "_self"
                );
              } else if (this.fromQuoteBuy) {
                window.open(
                  this.getCorrectUrl(
                    "/areariservata?tabToLoad=profile&fromQuoteBuy=yes"
                  ),
                  "_self"
                );
              }
            });
        } else if (this.fromAcceptInvitation) {
          let tenderId = localStorage.getItem("TENDER_ID");
          window.open(
            "/areariservata?tabToLoad=tenderDetail&tenderId=" + tenderId
          );
        } else if (this.fromCompanyShowcase) {
          window.open("/aziende", "_self");
        } else if (this.fromDesignerShowcase) {
          window.open("/professionisti", "_self");
        } else if (this.fromOngoingTenders) {
          window.open( "/gareincorso" 
               + (this.tenderId ? "?tenderId=" + this.tenderId : "") 
               + (this.invitationToken ? "&invitationToken=" + this.invitationToken : "") , "_self");
        }else if (this.fromAnnouncementShowcase) {
          window.open( "/annunci?type=" + this.announcementType, "_self" ); 
        } else {
          window.open("/areariservata?tabToLoad=dashboard", "_self");
        }
      })
      .catch((error) => {
        this.loginLoading = false;
        this.registrationLoading = false;

        if (error instanceof HttpErrorResponse) {
          if (error.error.returnCode == 401) {
            this.loginError = "Username o password sbagliati.";
          } else {
            if (error.error.returnCode == 400) {
              if (error.error.errors[0].text == "EMAIL_NOT_CONFIRMED") {
                this.loginError =
                  "Email non validata... connettiti alla tua casella di email per confermare il tuo indirizzo di posta elettronica";
              }
            } else {
              this.loginError =
                "Ops.. impossibile fare il login. Riprovare tra qualche minuto.";
            }
          }
        } else {
          this.loginError =
            "Ops.. impossibile fare il login. Riprovare tra qualche minuto.";
        }
      });
  }

  loginSubmitHandler() {
    this.loginLoading = true;
    if (!this.loginForm.valid) {
      this.loginError = "I campi non sono compilati correttamente";
      const controls = this.loginForm.controls;
      Object.keys(controls).forEach((controlName) =>
        controls[controlName].markAsDirty()
      );
      console.log("Invalid login form");
      this.loginLoading = false;
      return;
    }
    console.log("Login submit");
    console.log(this.loginForm.value);

    this.login(
      this.loginForm.value.loginUsername,
      this.loginForm.value.loginPassword
    );
  }

  registrationSubmitHandler() {
    this.registrationLoading = true;

    if (!this.registrationForm.valid) {
      this.registrationError = "I campi non sono compilati correttamente";
      const controls = this.registrationForm.controls;
      Object.keys(controls).forEach((controlName) =>
        controls[controlName].markAsDirty()
      );
      console.log("Invalid registration form");
      this.registrationLoading = false;
      return;
    }

    this.checkEmail().then(
      (value: any) => {
        this.registrationError = "L'email esiste già.";
        this.registrationLoading = false;
      },
      (error: HttpErrorResponse) => {
        if (error.error === 404) {
          this.resetRegistrationError();
          let formValues = this.registrationForm.getRawValue();
          console.log(formValues);
          delete formValues.passwordConfirm;

          let registration: Registration = formValues;

          registration.privacyAccepted = true; // this was formerly set by user, now it is useless

          this.commonService
            .getRegistrationService()
            .authRegistrationPost(registration)
            .subscribe(
              (loginResponse: LoginResponse) => {
                console.log(loginResponse);
                localStorage.setItem("TOKEN", loginResponse.token);
                this.registrationLoading = false;
                if (this.fromTender || this.fromClusterTender || this.fromQuoteBuy) {
                  this.login(
                    this.registrationForm.value.email,
                    this.registrationForm.value.password
                  );
                } else {
                  this.router.navigate(["/grazie"]);
                  //window.open('/grazie','_self');
                }
              },
              (error) => {
                var err = error.error.errors[0].text;
                if (err === "PASSWORD_NOT_FULFILLING_POLICIES") {
                  //this.registrationError = 'La password deve contenere almeno una lettera maiuscola, deve contenere almeno un numero, deve contenere almeno una lettera minuscola, deve essere lunga almeno 8 caratteri';
                  this.getPasswordPolicyMessage();
                } else {
                  this.registrationError =
                    "Impossibile completare la registrazione. Riprova più tardi.";
                }
                console.log(err);
                this.registrationLoading = false;
              }
            );
          console.log("Registration submit");
        }
      }
    );
  }

  checkEmail() {
    if (!this.registrationForm.get("email").valid) return null;

    var email = this.registrationForm.get("email").value;
    if (email === null || email === undefined || email === "") return null;

    console.log("Checking if email already exists");

    // var returnPromise = this.commonService.getAuthenticationService().authEmailsEmailGet(email);

    return new Promise((resolve, reject) => {
      this.commonService
        .getAuthenticationService()
        .authEmailsEmailGet(email)
        .subscribe(
          (value: any) => {
            resolve(value);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  resetRegistrationError() {
    this.registrationError = "no_error";
  }

  resetLoginError() {
    this.loginError = "no_error";
  }

  getPasswordPolicyMessage() {
    this.commonService
      .getConfigurationVariables()
      .then((variables: ConfigurationVariablesList) => {
        console.log(
          "PASSWORD_POLICY_MESSAGE: " + variables["PASSWORD_POLICY_MESSAGE"]
        );
        this.registrationError = variables["PASSWORD_POLICY_MESSAGE"];
      });
  }
}
